import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { BASE_URL_TRIAL } from '@/constants/base-url';

import axiosInstance from '../configs/axios';

interface BaseCheckoutProps {
  click_id?: string | null;
  gateway_id: number;
  plan_id: number;
  coupon: string;
}

export interface CheckoutPix {
  payment_method: string;
  user_doc: string;
  click_id?: string | null;
  gateway_id: number;
  plan_id: number;
  coupon: string;
  ref: string;
}

export interface CheckoutCreditCardProps extends BaseCheckoutProps {
  cc_token: string;
  data_authentication?: {
    cavv: string;
    eci: string;
    xid: string | null;
    version: string;
    referenceId: string;
  };
}

export const checkoutcieloPix = createAsyncThunk('appCheckoutCielo/cieloPix', async (data: CheckoutPix) => {
  try {
    const response = await axiosInstance.post('/checkout', data);
    // @ts-ignore
    return { success: response.data.success, status: response.status, data: response.data.data, campaign_discount_applied: response.data?.campaign_discount_applied, campaign_discount_refused_reason: response.data?.campaign_discount_refused_reason };
  } catch (error) {
    // @ts-ignore
    const errorResponse = error?.response;
    const { success, data: errorData } = errorResponse.data;
    return { success, status: errorResponse.status, error: errorData };
  }
});

export const checkoutcieloCreditCard = createAsyncThunk('appCheckoutCielo/cieloCreditCard', async (data: CheckoutCreditCardProps) => {
  try {
    const response = await axiosInstance.post('/checkout', data);
    // @ts-ignore
    return { success: response.data.success, status: response.status, data: response.data.data, campaign_discount_applied: response.data?.campaign_discount_applied, campaign_discount_refused_reason: response.data?.campaign_discount_refused_reason };
  } catch (error) {
    // @ts-ignore
    const errorResponse = error?.response;
    const { success, data: errorData } = errorResponse.data;
    return { success, status: errorResponse.status, error: errorData };
  }
});

export const checkoutcieloTrialCreditCard = createAsyncThunk('appCheckoutCielo/cieloTrialCreditCard', async (data: CheckoutCreditCardProps) => {
  try {
    const response = await axiosInstance.post(`${BASE_URL_TRIAL}`, data);
    // @ts-ignore
    return { success: response.data.success, status: response.status, data: response.data.data, campaign_discount_applied: response.data?.campaign_discount_applied, campaign_discount_refused_reason: response.data?.campaign_discount_refused_reason };
  } catch (error) {
    // @ts-ignore
    const errorResponse = error?.response;
    const { success, data: errorData } = errorResponse.data;
    return { success, status: errorResponse.status, error: errorData };
  }
});

export const appCheckoutStripeSlice = createSlice({
  name: 'appCheckoutCielo',
  initialState: {
    data: [],
  },
  reducers: {},
});

export default appCheckoutStripeSlice.reducer;
